"use client";

import Carousel from "../../../../carousel/carousel";
import ProductNoMediaCard from "../../../../market-place/product-no-media-card";
import BaseSimilarProducts from "../../shared/product/base-similar-products";
import styles from "./index.module.css";
import PopUp from "./popUp";
import SimilarProductSkeletonCard from "./similar-product-skeleton-card";
import { useProductPriceDisplay } from "./useProductPriceDisplay";

const SimilarProducts = (props) => (
  <BaseSimilarProducts
    {...props}
    styles={styles}
    PopUp={PopUp}
    SimilarProductSkeletonCard={SimilarProductSkeletonCard}
    usePriceDisplay={useProductPriceDisplay}
    paginationVariant="conveti"
    renderProductMedia={({ product, media, hasMedia }) => (
      <div className={styles.similarProductMedia}>
        {hasMedia ? (
          <Carousel
            media={media}
            enablePreview={false}
            enableZoom={false}
            autoscroll={true}
            showIndicator={false}
            hideThumb={true}
            customHeight="100%"
            skeletonHeight="100%"
            galleryContainerClassName="similar-product similar-product-conveti"
          />
        ) : (
          <ProductNoMediaCard product={product} showBorder={false} />
        )}
      </div>
    )}
  />
);

export default SimilarProducts;
